import flagAT from "../../assets/flags/at.svg";
import flagAU from "../../assets/flags/au.svg";
import flagBE from "../../assets/flags/be.svg";
import flagCA from "../../assets/flags/ca.svg";
import flagCZ from "../../assets/flags/cz.svg";
import flagDE from "../../assets/flags/de.svg";
import flagDK from "../../assets/flags/dk.svg";
import flagES from "../../assets/flags/es.svg";
import flagEU from "../../assets/flags/eu.svg";
import flagFI from "../../assets/flags/fi.svg";
import flagFR from "../../assets/flags/fr.svg";
import flagGB from "../../assets/flags/gb.svg";
import flagIE from "../../assets/flags/ie.svg";
import flagIT from "../../assets/flags/it.svg";
import flagJP from "../../assets/flags/jp.svg";
import flagNL from "../../assets/flags/nl.svg";
import flagNO from "../../assets/flags/no.svg";
import flagNZ from "../../assets/flags/nz.svg";
import flagPL from "../../assets/flags/pl.svg";
import flagSE from "../../assets/flags/se.svg";
import flagUS from "../../assets/flags/us.svg";
import flagWW from "../../assets/flags/ww.svg";

interface I18nImageMap {
  [key: string]: string;
}

export const flagsI18N: I18nImageMap = {
  at: flagAT,
  au: flagAU,
  be: flagBE,
  ca: flagCA,
  cz: flagCZ,
  de: flagDE,
  dk: flagDK,
  es: flagES,
  eu: flagEU,
  fi: flagFI,
  fr: flagFR,
  gb: flagGB,
  ie: flagIE,
  it: flagIT,
  jp: flagJP,
  nl: flagNL,
  no: flagNO,
  nz: flagNZ,
  pl: flagPL,
  se: flagSE,
  us: flagUS,
  ww: flagWW,
};
